import React from 'react';
import { Button, Popconfirm, Tooltip } from 'antd';
import { Lock, Undo2 } from 'lucide-react';
import { StatusTag } from '../../common';
import { fmtVZ } from '../../../utils/timeUtils';

/** Column header for one role: name, state pill (fixed / default / unsaved / customized) and "Restablecer". */
export default function RoleHeader({ role: r, dirty, saving, onReset }) {
    let tag = <StatusTag tone="neutral">Por defecto</StatusTag>;
    if (!r.editable)
        tag = (
            <StatusTag tone="neutral" icon={<Lock />}>
                Fijo
            </StatusTag>
        );
    else if (dirty.has(r.role))
        tag = (
            <StatusTag tone="brand" dot>
                Sin guardar
            </StatusTag>
        );
    else if (r.customized) tag = <StatusTag tone="warning">Personalizado</StatusTag>;

    return (
        <div className="flex flex-col items-center gap-1.5 py-1 text-center">
            <span className="text-[13px] font-semibold text-surface-900">{r.label}</span>
            {r.customized && r.updatedAt ? (
                <Tooltip title={`Modificado ${fmtVZ(r.updatedAt, 'DD/MM/YYYY HH:mm')}${r.updatedByName ? ` por ${r.updatedByName}` : ''}`}>
                    <span>{tag}</span>
                </Tooltip>
            ) : (
                tag
            )}
            {r.editable && r.customized && !dirty.has(r.role) && (
                <Popconfirm
                    title={`¿Restablecer ${r.label}?`}
                    description="Vuelve a los permisos por defecto de este rol."
                    okText="Restablecer"
                    cancelText="Cancelar"
                    onConfirm={() => onReset(r.role)}>
                    <Button type="link" size="small" icon={<Undo2 />} disabled={saving} className="!h-auto !p-0 !text-xs">
                        Restablecer
                    </Button>
                </Popconfirm>
            )}
        </div>
    );
}
